"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMergedTags = void 0;
const Object_1 = require("helpers/Object");
const constants_1 = require("../constants");
const DEFAULT_KEYS = [
    constants_1.CERTIFICATE_KEY.ATTENDANCE,
    constants_1.CERTIFICATE_KEY.COURSE,
    constants_1.CERTIFICATE_KEY.ORGANIZER,
    constants_1.CERTIFICATE_KEY.END_DATE,
    constants_1.CERTIFICATE_KEY.CLASS_NAME
];
const DEFAULT_VALUES = [
    constants_1.CERTIFICATE_TAG.ATTENDANCE,
    constants_1.CERTIFICATE_TAG.COURSE,
    constants_1.CERTIFICATE_TAG.ORGANIZER,
    constants_1.CERTIFICATE_TAG.END_DATE,
    constants_1.CERTIFICATE_TAG.CLASS_NAME
];
const DEFAULT_LABELS = [
    constants_1.CERTIFICATE_KEY.ATTENDANCE,
    constants_1.CERTIFICATE_KEY.COURSE,
    constants_1.CERTIFICATE_KEY.ORGANIZER,
    constants_1.CERTIFICATE_KEY.END_DATE,
    constants_1.CERTIFICATE_KEY.CLASS_NAME
];
const getMergedTags = (isQrCodeEnabled) => {
    let keys = DEFAULT_KEYS, labels = DEFAULT_LABELS, values = DEFAULT_VALUES;
    if (isQrCodeEnabled) {
        keys = [...DEFAULT_KEYS, constants_1.CERTIFICATE_KEY.QR_CODE];
        values = [...DEFAULT_VALUES, constants_1.CERTIFICATE_TAG.QR_CODE];
        labels = [...DEFAULT_LABELS, constants_1.CERTIFICATE_KEY.QR_CODE];
    }
    return (0, Object_1.createSelectOptions)(values, labels, keys);
};
exports.getMergedTags = getMergedTags;
